import { call, put, takeEvery } from 'redux-saga/effects';
import { 
  deleteBookmarkRequest, 
  deleteBookmarkSuccess, 
  deleteBookmarkFailure 
} from '../slice/deleteBookmarkSlice';
import { deleteBookmarkApi } from '../../api/apiService';
import { getApiError } from "@src/utils/apiError";

// Worker saga
export function* handleDeleteBookmark(action: { payload: { bookmarkId: string } }): Generator<any, void, any> {
  try {
    const response = yield call(deleteBookmarkApi as any, action.payload.bookmarkId);

    if (response && response.data.success) {
      yield put(deleteBookmarkSuccess());
    } else {
      yield put(deleteBookmarkFailure('Unexpected response from server'));
    }
  } catch (error: unknown) {
    const apiError = getApiError(error);
    console.error(
        "Delete Bookmark Error:",
        error
    );
    yield put(
        deleteBookmarkFailure(
            apiError.message
        )
    );
}
}


// Watcher saga
export function* deleteBookmarkSaga() {
  yield takeEvery(deleteBookmarkRequest, handleDeleteBookmark);
}
